import PlatformFooter from '../appComponents/mobile/PlatformFooter';
import '../appComponents/desktop/css/PlatformFooterDesktop.css';
import '../appComponents/desktop/css/DesktopModalStyles.css';
import { switchPlatformTheme } from '../appComponents/shared/ThemePreference';
import '../appComponents/shared/css/PlatformExperience.css';
import '../appComponents/shared/css/CreditFlowRefinement.css';
import './css/NewCreditRailPolish.css';
import PageLoading from '../appComponents/shared/PageLoading';
import { trackPageRequest } from '../appComponents/shared/PageLoadingService';
import '../appComponents/shared/crypto/css/OverlayTheme.css';
import { authenticatedPut } from '../appComponents/shared/AuthenticatedAPI';
import PasswordPrompt from '../appComponents/shared/crypto/PasswordPrompt';
import React, { Component } from 'react';

class NewBorrowingAccountDesktopRender extends Component {
  render() {
    const { API, AWS, Amplify, Auth, Storage, Button, ButtonContent, ButtonGroup, Modal, Header, Image, Container, ListList, ListItem, ListIcon, Icon, Input, ListHeader, ListDescription, ListContent, List, FormField, Form, Radio, Mosaic, OrbitProgress, ThreeDot, LoadingIcons, Link, Fragment, navigationHandler, routeProps, isMobile, ethers, Web3, CryptoJS, mimemessage, awsconfig, deploymentAddressLatest, CampaignContract_latest, CampaignFactoryContract_latest, tokenLifeTimeLimit, checkValidAuthTokenIntervalPeriod_ms, LENDERBLOCKADMINWHITELIST, primaryLanguage, mode_light_dark, web3, highRateWeb3, checkValidAuthTokenInterval, cognitoID, currentUser, currentUserCap, primaryDisplayCurrency, secondaryDisplayCurrency, publicKey, corporateBackedUsernamesArray, weiBalance, that, applicantUsername, monthLengtheningEnum, touched, className } = this.props;

    return (
          <div className={"pageBody tbp-platform tbp-platform--" + (that.state.mode_light_dark === 'light' ? 'light' : 'dark') + " tbp-platform--new-borrowing-account tbp-platform--desktop"}>
              <PageLoading theme={that.state.mode_light_dark} language={that.state.selectedLanguage} busy={Boolean(that.state.freezeButtonsBool || that.state.activityIndicator === true)} />

            
                    
      
            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
                open={that.state.errorTags}
                // open={true}
                style={{
                width: '25vw',
                justifyContent: 'center',
                alignItems: 'center',
                }}
            >
                <Modal.Header
                  style={{
                    paddingLeft: '7vh',
                  }}
                >
                  
                  The Blender Platform
                </Modal.Header>
              
                <Modal.Content 
                image
                style={{
                    justifyContent: 'space-between',
                    marginBottom: '1vh',
                }}
                >
                
                <Modal.Description
                    style={{
                    width: '25vw',
                    }}
                >
                    <Header
                    style={{
                        // left: '16vw',
                        fontSize: 20,
                        // position: 'absolute',
                        overflowY: 'hidden',
                        overflowX: 'hidden', 
                        width: '25vw',
                        marginBottom: 65,
                        paddingRight: '1vw',
                    }}
                    >
                        <p
                        style={{
                            color: 'rgba(235, 50, 38, 1)',
                            textAlign: 'left',
                            textWrap: 'wrap',
                        }}
                        >
                        {that.state.selectedLanguage == 'spanish' ? 
                            'Error:'
                                :
                            'Error:'
                        }
                        </p>
                        <p
                        style={{
                            color: 'rgba(0, 0, 0, 1)',
                            textAlign: 'left',
                            textWrap: 'wrap',
                            fontWeight: '400',
                            fontSize: 18,
                            paddingRight: '1vw',
                        }}
                        >
                        {that.state.errorTags}
                        </p>
                    </Header>
                </Modal.Description>
                </Modal.Content>
                <Button
                    content={
                        that.state.selectedLanguage == 'spanish' ? 
                        'Bueno'
                            :
                        'Okay'
                    }
                    labelPosition='right'
                    icon='checkmark'
                    onClick={() => {
                        that.setState({
                            successfulDepositOverlay: false,
                            errorTags: null
                        })
                    }}
                    positive
                    style={{
                        backgroundColor: 'rgba(0, 158, 129, 1)',
                        position: 'relative',
                        bottom: 21,
                        fontSize: 15,
                        width: '7vw',
                        marginLeft: '9vw',
                        marginRight: '9vw',
                        // left: '0vw',
                        borderRadius: 2,
                    }}
                />
            </Modal>


            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.generalNoticeOverlay}
              // open={true}
              style={{
                width: '29vw',
                height: '25vh',
              }}
              // trigger={<Button>Show Modal</Button>}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
                
                
              <Modal.Content image>
                <Modal.Description>
                  <Header
                    style={{
                      left: '1vw',
                      marginRight: '1vw',
                      position: 'absolute',
                    }}
                  >{`${that.state.generalNoticeText}`}</Header>
                  <Button
                    content="Okay"
                    labelPosition='right'
                    icon='checkmark'
                    onClick={() => {
                      that.setState({
                        generalNoticeOverlay: false,
                      })
                    }}
                    positive
                    style={{
                      backgroundColor: 'rgba(0, 158, 129, 1)',
                      position: 'absolute',
                      bottom: 21,
                      width: '7vw',
                      left: '11vw',
                    }}
                  />
                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>
            
              
              
              
            <PasswordPrompt desktop
              open={that.state.showPasswordOverlay}
              theme={that.state.mode_light_dark}
              language={that.state.selectedLanguage}
              message={that.state.transactionConfirmationMessage}
              value={that.state.passwordText || ''}
              onChange={(event) => {
                          that.setState({
                            passwordText: event.target.value
                          })
                      }}
              onConfirm={() => {
                        that.setState({
                          showPasswordOverlay: false,
                          pendingTransactionLoaderOverlay: true,
                        })
                        if(that.state.moneyTransactionPreset == 'lend'){
                          that.contributeTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'withdraw'){
                          that.createWithdrawalReqTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'reclaim'){
                          that.rescindTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'repay'){
                          that.repayTxn(that.state.passwordText)
                        }
                      }}
              onCancel={() => {
                that.setState({
                  showPasswordOverlay: false,
                  passwordText: null,
                  passwordIsHiddenBool: true,
                })
              }}
            />


            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.popupBlockerOverlay}
              // open={true}
              style={{ 
                width: '35vw',
                height: '21vh',
              }}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                {that.state.selectedLanguage == 'spanish' ? 
                  `Se están bloqueadas las ventanas emergentes de Blender.`
                    :
                  `Your browser may be blocking Blender pop-ups.`
                }
              </Modal.Header>
              <Modal.Content image>
                {/* <Modal.Description> */}
                  <Header
                    style={{
                      left: '0vw',
                      position: 'relative',
                      paddingRight: '1vw',
                    }}
                  >
                    {that.state.selectedLanguage == 'spanish' ? 
                      `Habilite ventanas "pop-up" del browser para completar tu transacción.`
                      :
                      `Enable Pop-Up tabs and windows to complete your transaction.`
                    }
                  </Header>
                  <Button
                    content={that.state.selectedLanguage == 'spanish' ? "Bueno" : 'Okay'}
                    labelPosition='right'
                    icon='checkmark'
                    onClick={() => {
                      that.setState({
                        popupBlockerOverlay: false
                      })
                    }}
                    positive
                    style={{
                      backgroundColor: 'rgba(0, 158, 129, 1)',
                      position: 'absolute',
                      bottom: 21,
                      width: '7vw',
                      left: '14vw',
                    }}
                  />
                {/* </Modal.Description> */}
              
                
                </Modal.Content>
            </Modal>



            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.successOverlay}
              // open={true}
              style={{
                width: '33vw',
                height: '25vh',
              }}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
              <Modal.Content image>
                {/* <Modal.Description> */}
                  <Header
                    style={{
                      left: '0vw',
                      position: 'relative',
                      paddingRight: '1vw',
                    }}
                  >
                    {that.state.selectedLanguage == 'spanish' ? 
                      'Cuenta Creado!  '
                        :
                      'Account Created!  '
                    }
                    &nbsp;
                    &nbsp;
                    <p
                      style={{
                        marginTop: 20,
                      }}
                    >
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Busque su email en pronto\n para confirmación segunda.'
                          :
                        'Check your email soon\nfor a second confirmation.'
                      }
                    </p>
                  
                  </Header>
                  <Button
                    content="Okay"
                    labelPosition='right'
                    icon='checkmark'
                    onClick={() => {
                      that.setState({
                        successOverlay: false
                      })
                    }}
                    positive
                    style={{
                      backgroundColor: 'rgba(0, 158, 129, 1)',
                      position: 'absolute',
                      bottom: 21,
                      width: '7vw',
                      left: '13vw',
                      right: '13vw',
                    }}
                  />
                {/* </Modal.Description> */}
              
                
                </Modal.Content>
            </Modal>

            

            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.lowBalanceOverlay}
              // open={true}
              style={{
                width: '27vw',
                height: '25vh'
              }}
              // trigger={<Button>Show Modal</Button>}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
                
              <Modal.Content image>
                <Modal.Description>
                  <Header
                    style={{
                      left: '3vw',
                      marginTop: '1vh',
                      marginRight: '1vw',
                      position: 'absolute',
                    }}
                  >
                    <p style = {{  
                      color: 'rgba(0, 0, 0, 1)',
                      fontSize: 22,
                      fontWeight: '600',
                      textAlign: 'left',
                      textShadowColor: 'rgba(0, 0, 0, 0.10)',
                      textShadowOffset: {width: -1, height: 1},
                      textShadowRadius: 10, 
                    }}>
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Valor Bajo de Carter Blender\n\n'
                          :
                        'Low Blender Wallet Balance\n\n'
                      }
                      <p style = {{  
                        color: 'rgba(0, 158, 129, 1)',
                        fontSize: 18,
                        fontWeight: '600',
                        textAlign: 'left',
                      }}>
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Querias depositar\npor su tarjeta de banco?'
                            :
                          'Would you like to top-up\nusing your debit card?'
                        }
                      </p>
                  
                    </p>
                  </Header>




                  <div
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'center', 
                      // alignItems: 'center',
                      position: 'absolute',
                      bottom: 0, 
                      left: 0, 
                      right: 0,
                      
                      // backgroundColor: 'red',
                      // width: '30vw',
                      // paddingLeft: 25,
                      // paddingRight: 25,
                    }}
                  >
                  
                    <Button
                      content={that.state.selectedLanguage == 'spanish' ? 
                        'Depositar Fondos'
                          :
                        'Deposit Funds'
                      }
                      labelPosition='right'
                      icon='checkmark'
                      onClick={() => {
                        that.setState({
                          lowBalanceOverlay: false,
                          inProcessLoading: true,
                        })
                      }}
                      positive
                      style={{
                        position: 'absolute',
                        right: '3vw',
                        bottom: 20,
                        color: 'rgba(255, 255, 255, 1)',
                        // marginLeft: 25,
                        backgroundColor: 'rgba(0, 158, 129, 1)',
                      }}
                    />
                    <Button
                      content={that.state.selectedLanguage == 'spanish' ? 
                        'No'
                          :
                        'No'
                      }
                      labelPosition='right'
                      icon='close'
                      onClick={() => {
                        that.setState({
                          lowBalanceOverlay: false,
                        })
                      }}
                      positive
                      style={{
                        position: 'absolute',
                        left: '3vw',
                        bottom: 20,
                        color: 'rgba(255, 255, 255, 1)',
                        backgroundColor: 'rgba(204, 12, 12, 1)',
                      }}
                    />
                  </div>

                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.pendingTransactionLoaderOverlay}
              // open={true}
              style={{
                width: '18vw',
              }}
              // trigger={<Button>Show Modal</Button>}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
              <Modal.Content image>
                <Modal.Description>
                  <Header
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginLeft: '2vw',
                      marginRight: '3vw',
                      marginTop: '0vw',
                      marginBottom: '0vw',
                      height: '5vw',
                    }}
                  >
                    <p
                      style={{
                        fontSize: 19,
                        color: 'rgba(0, 0, 0, 1)',
                        textAlign: 'left',
                        marginBottom: '2vh',
                      }}
                    >
                      {
                        that.state.selectedLanguage == 'spanish' 
                        ? 
                          "Transacción Pendiente"
                        :
                          "Transaction in Progress"
                      }
                    </p>
                    
                    <div
                      style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '4vw',
                        marginLeft: '3vw',
                        marginRight: '3vw',
                        // paddingLeft: '5vw',
                        // paddingRight: '5vw', 
                      }}
                    >
                      <div className="tbp-overlay-loading"><ThreeDot 
                        color="rgba(0, 158, 129, 1)" 
                        size="large" 
                        style={{
                          marginTop: 250,
                          speedPlus: -2,
                        }}
                      /></div>
                    </div>
                  
                  </Header>
                  
                </Modal.Description>
                
              </Modal.Content>
            </Modal>
          

            <div className="tbp-platform__sidebar" style={{
              // borderRadius: 10,
              justifyContent: 'center',
              alignItems: 'center',
              width: '13vw',
              height: '100vh',
              margin: 0,
              left: 0,
              position: 'absolute',
              borderRightStyle: 'solid',
              borderWidth: 0.1,
              backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
            }}>
              <Button
                onClick={() => {
                  that.setState({
                    navigationDestinationObject: {
                        navigationRoute: '/home',
                    },
                  })
                }}
                style={{
                  position: 'relative',
                  left: '2vw',
                  top: '1vw',
                  height: '5vw',
                  width: '5vw',
                  marginBottom: '2vh',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: 'rgba(0, 0, 0, 0)',
                }}
              >
                <img 
                  // className="logoImage" 
                  src="https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png"
                  style={{
                    height: '4vw',
                    width: '4vw',
                    position: 'absolute',
                    top: 7, 
                    left: 3, 
                    right: 0,
                    borderRadius: 7,
                    borderStyle: 'solid',
                    borderWidth: 0.1,
                    borderColor: 'rgba(177, 177, 177, 0.1)',
                  }}
                />
              </Button>
                


              <List>
                <ListItem
                  style={{
                    marginBottom: 10,

                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    className="ui huge teal button"
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/home',
                        },
                      })
                    }}
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="home icon"/>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Activos'
                          :
                        'Accounts'
                      }
                    </p>
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/browser',
                        },
                      })
                    }}
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    className="ui huge teal button"
                    
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="search icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Buscar'
                          :
                        'Browse'
                      }
                    </p>
                    
                  </button>
                </ListItem>

                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    // onClick={() => {
                    //   that.setState({
                    //     navigationDestinationObject: {
                    //         navigationRoute: '/newborrowingacct',
                    //     },
                    //   })
                    // }}
                    className="ui huge teal button"
                      
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="newspaper icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Tomar Prestamo'
                          :
                        'Borrow Funds'
                      }
                    </p>
                    
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/membertransactions',
                        },
                      })
                    }}
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    className="ui huge teal button"
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="wait icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Transacciones'
                          :
                        'Transactions'
                      }
                    </p>
                    
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/SubscriptionPlan',
                        },
                      })
                    }}
                    className="ui huge teal button"
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="star icon"></i>
                      &nbsp;  
                      {'Blender Pro Plus'}
                    </p>
                    
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    onClick={() => {
                      var win = window.open('https://lenderblockcorp.com/termsandconditions-tbp', '_blank');
                      win.focus();
                    }}
                    className="ui huge teal button"
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                      }}
                    >
                      <i className="book icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Condiciones'
                          :
                        'Terms of Use'
                      }
                    </p>
                    
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    onClick={() => {
                      var win = window.open('https://lenderblockcorp.com/privacypolicy-tbp', '_blank');
                      win.focus();
                    }}
                    className="ui huge teal button"
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="book icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Privacidad'
                          :
                        'Privacy Policy'
                      }
                    </p>
                    
                  </button>
                </ListItem>
              </List>



              <button 
                style={{
                  position: 'fixed',
                  bottom: 20,
                  marginBottom: 10,
                  marginLeft: 25,
                  borderRadius: 20,
                  backgroundColor: 'rgba(0, 158, 129, 0)',
                  borderWidth: 2,
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: 15,
                }}
                onClick={() => { 
                  trackPageRequest(Auth.signOut())
                  that.setState({
                    navigationDestinationObject: {
                        navigationRoute: '/welcome',
                    },
                  }) 
                }}
                className="ui medium teal button"
              >
                <p
                  style={{
                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                  }}
                >
                  <i className="sign out icon"/>
                  {that.state.selectedLanguage == 'spanish' ? 
                    'Desconectar'
                      :
                    'Sign Out'
                  }
                </p>
              </button>
            </div>






            <div className="tbp-platform__workspace" style={{
              // backgroundColor: 'blue',
              // borderRadius: 10, 
              justifyContent: 'center',
              alignItems: 'center',
              width: '87vw',
              height: '100vh',
              margin: 0,
              flexDirection: 'column',
              // borderStyle: 'none',
              borderWidth: 0,    
              position: 'absolute',
              left: '13vw',
              top: '0vh',
              // border: 'none',   
              // borderColor: 'rgba(177, 177, 177, 0)',
            }}>
            
              <div className="tbp-platform__topbar" style={{
                // backgroundColor: 'rgba(0, 158, 129, 0)',
                // borderRadius: 10,
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '87vw',
                height: '7vh',
                paddingLeft: '3vw',
                margin: 0,
                display: 'flex',
                flexDirection: 'row',
                paddingRight: '10vw',
                borderBottomStyle: 'solid',
                borderWidth: 0.1,
                borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              }}>
                <p 
                  style={{ 
                    textAlign: 'left',
                    textAlignVertical: 'center',
                    fontSize: 23, 
                    fontWeight: '600', 
                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                    marginTop: 30, 
                    marginBottom: 30,
                    // textUnderlineOffset: 3, 
                    // textDecorationLine: 'underline', 
                    // textDecorationColor: 'rgba(255, 255, 255, 1)',
                  }}
                >
                    <span className="tbp-platform__eyebrow">THE BLENDER PLATFORM</span><span className="tbp-platform__title">{that.state.selectedLanguage === 'spanish' ? "Nueva línea de crédito" : "New credit line"}</span>  
                </p>


                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    position: 'absolute',
                    right: 0,
                    padding: 10,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingRight: 25,
                    borderRadius: 17
                  }}
                >
                  <Button
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/accountmanagement',
                        },
                      })
                    }}
                    style={{
                      borderBottomLeftRadius: 18,
                      borderBottomRightRadius: 5,
                      borderTopLeftRadius: 18,
                      borderTopRightRadius: 5,
                      height: '40px',
                      borderWidth: 2,
                      marginLeft: 25,
                      marginRight: 10,
                      backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(35, 35, 35, 1)', 
                      borderColor: 'rgba(224, 225, 226, 0)',
                      borderStyle: 'solid', 
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                      flexDirection: 'row',
                      transitionDuration: '0.4s',
                      cursor: 'pointer',
                      padding: 0,
                    }}
                  >
                    <img 
                      className="header_profileImage" 
                      width="35" 
                      height="35" 
                      src={that.state.currentUserProfilePicture}
                    />

                    <p 
                      style={{ 
                        textAlign: 'right',
                        textAlignVertical: 'center',
                        fontSize: 16, 
                        fontWeight: '600', 
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                        marginLeft: 12, 
                        marginRight: 15,
                        marginTop: 5,
                        // textUnderlineOffset: 3, 
                        // textDecorationLine: 'underline', 
                        // textDecorationColor: 'rgba(255, 255, 255, 1)',
                      }}
                    >
                        {String(that.state.currentUser).toUpperCase()}
                    </p>
                  </Button>
                </div>



                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    position: 'absolute',
                    right: 200,
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 17,
                    backgroundColor: 'rgba(35, 35, 35, 0)',
                    borderRadius: 17,
                    width: '5vw',
                    height: '7vh', 
                  }}
                >


                  <button
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '2.5vw',
                      height: '7vh', 
                      paddingTop: '2.5vh',
                      paddingBottom: '1vh',
                      backgroundColor: 'rgba(35, 35, 35, 0)',
                      borderStyle: 'none',
                    }}
                    onClick={() => switchPlatformTheme({ that, authenticatedPut, currentUser })}
                  >
                    <p style={{ 
                      justifyContent: 'center',
                      textAlign: 'center',
                      textAlignVertical: 'center',
                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',

                      fontWeight: '600',
                    }}>
                      <p style={{ 
                        justifyContent: 'center',
                        textAlign: 'center',
                        textAlignVertical: 'center',
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',

                        fontWeight: '600',
                      }}>
                        <i
                          style={{
                            fontSize: that.state.mode_light_dark == 'dark' ? 34 : 31, 
                            marginBottom: 5, 
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                            marginLeft: 5,
                          }}
                          className={that.state.mode_light_dark == 'dark' ? "sun icon" :"moon icon"}
                        />
                      </p>
                    </p>
                  </button>

                </div>   

              </div>
              
              <div className="tbp-platform__body" style={{
                // backgroundColor: 'blue',
                // borderRadius: 10,
                justifyContent: 'center',
                alignItems: 'center',
                width: '87vw',
                height: '93vh',
                margin: 0,
                borderStyle: 'none',
                borderWidth: 0,
                backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              }}>
                <div 
                  className="scrollNoScrollBar tbp-newcredit-screen-scroll"
                  style={{
                    // borderRadius: 10,
                    // backgroundColor: 'red',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '62vw',
                    position: 'fixed',
                    left: '13vw',
                    // top: 0, 
                    // bottom: 0, 
                    height: '93vh',
                    marginTop: 0,
                    marginBottom: 0,
                    marginRight: 0,
                    marginLeft: '0vw',
                    borderStyle: 'none',
                    borderWidth: 0,
                    scrollbarWidth: 'none',
                    overflowY: 'hidden',
                    overflowX: 'hidden',
                    backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
                  }}
                >


                  <div
                    styles={{
                      marginTop: 1,
                      minHeight: '88vh',
                      width: '62vw',
                    }}
                  >
                    <div className="tbp-newcredit-spacer"
                    style={{
                        width: '62vw',
                        height: '10vh',
                        display: 'flex',
                        borderRadius: 3,
                        // backgroundColor: 'rgba(177, 177, 177, 1)',
                        justifyContent: 'center',
                        // borderColor: 'red',

                      }}
                    >

                    </div>
                    <div className='flipContainer tbp-newcredit-shell'
                      style={{
                        width: '62vw',
                        minHeight: '88vh',
                        flexDirection: 'row',
                        display: 'flex',
                        borderRadius: 3,
                        borderColor: 'rgba(177, 177, 177, 1)',
                        justifyContent: 'center',
                        // borderColor: 'red',

                      }}
                    >  {/* main */}


                      <div className='flipContainer active tbp-newcredit-shell-inner'
                        style={{
                          width: '62vw',
                          minHeight: '88vh',
                          flexDirection: 'column',
                          display: 'flex',
                          borderRadius: 3,
                          borderColor: 'rgba(177, 177, 177, 1)',
                          justifyContent: 'center',
                          borderColor: 'yellow',
                        }}
                      >
                        
                        <div
                          styles={{
                            marginTop: 1,
                            minHeight: '88vh',
                          }}
                        >
                          <div className='flipContainer tbp-newcredit-main'
                            style={{
                              width: '62vw',
                              minHeight: '88vh',
                              flexDirection: 'row',
                              display: 'flex',
                              borderRadius: 3,
                              borderColor: 'rgba(177, 177, 177, 1)',
                              justifyContent: 'center',
                              // borderColor: 'red',

                            }}
                          >  {/* main */}

                            <div
                              className="tbp-newcredit-intro" style={{
                                width: '62vw',
                                height: '10vh',
                                marginBottom: '6vh',
                                flexDirection: 'row',
                                display: 'flex',
                                borderRadius: 3,
                                borderColor: 'rgba(177, 177, 177, 1)',
                                justifyContent: 'space-between',
                                borderColor: 'red',
                                paddingLeft: '3vw',
                              }}
                            >
                              <p 
                                style={{ 
                                  textAlign: 'left',
                                  textAlignVertical: 'center',
                                  fontSize: 18, 
                                  fontWeight: '600', 
                                  color: 'rgba(0, 158, 129, 1)',
                                  marginTop: 30, 
                                  marginBottom: 30,
                                  // textUnderlineOffset: 3, 
                                  // textDecorationLine: 'underline', 
                                  // textDecorationColor: 'rgba(255, 255, 255, 1)',
                                }}
                              >
                                {that.state.selectedLanguage == 'spanish' ? 
                                  'Bienvenido a Blender Crédito!  '
                                    :
                                  'Welcome to Blender Credit!  '
                                }
                                
                                <p
                                  style={{
                                    textAlign: 'left',
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                    fontSize: 15, 
                                  }}
                                >
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'El crecer su propia'
                                      :
                                    'Creating your own'    
                                  }
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    ' Línea de Crédito Blender '
                                      :
                                    ' Blender Credit Line '
                                  }
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'es una acción fundamental y gratificante por crecer economías a través de la sociedad.  Participe hoy.'
                                      :
                                    'is a rewarding and fundamental action towards the creation of socio-economics.  Take part today.'
                                  }
                                </p>
                                
                              </p>
                            </div>

                            <div
                              className='flipContainer active tbp-newcredit-fields'
                              style={{
                                width: '62vw',
                                height: '35vh',
                                flexDirection: 'row',
                                display: 'flex',
                                borderRadius: 3,
                                borderColor: 'rgba(177, 177, 177, 1)',
                                justifyContent: 'space-between',
                                borderColor: 'green',
                                marginTop: '13vh',
                                marginLeft: '3vw',
                              }}
                            >
                        
                              <div className="tbp-newcredit-field tbp-newcredit-field--rate"
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  width: '31vw',
                                  height: '83vh',
                                }}
                              >
                                <p 
                                  style={{ 
                                    textAlign: 'left',
                                    textAlignVertical: 'center',
                                    fontSize: 17, 
                                    fontWeight: '600', 
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                    marginTop: 30, 
                                    marginBottom: 30,
                                    height: 50,
                                    width: '25vw',
                                    // textUnderlineOffset: 3, 
                                    // textDecorationLine: 'underline', 
                                    // textDecorationColor: 'rgba(255, 255, 255, 1)',
                                  }}
                                >
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'Establezca la tasa de interés anual a cual se capitalizará su deuda.'
                                      :
                                    'Set the Annual Interest Rate at which your debt will compound.'
                                  }
                                </p>
                                <p className="tbp-newcredit-unit"
                                  style={{
                                    position: 'absolute',
                                    top: '15vh', 
                                    right: '9vw',
                                    fontSize: 70,
                                    fontWeight: '600',
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 1)',
                                  }}
                                >
                                  {'%'}
                                </p>
                                <input className="tbp-newcredit-input" 
                                  type="text" 
                                  id="text" 
                                  outline="none"
                                  autocomplete="off"
                                  onChange={(event) => {
                                      that.setState({
                                        intRate_commOffer_Input: Number(event.target.value).toFixed(0)
                                      })
                                  }} 
                                  name="text"
                                  maxLength={2}
                                  placeholder={`${Number(that.state.intRate_commOffer_Input).toFixed(0)}`} 
                                  disabled={that.state.readyForFinalizationBool}
                                  style={{
                                    fontWeight: '600',
                                    fontFamily: 'arial',
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                    padding: '3vw',
                                    textAlign: 'left',
                                    textAlignVertical: 'center',
                                    fontSize: 18,
                                    height: '20vh',
                                    width: '25vw',
                                    borderRadius: 0,
                                    borderStyle: 'none',
                                    borderWidth: 0,
                                    fontSize: 80,
                                    borderColor: 'rgba(177, 177, 177, 0)',
                                    backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(255, 255, 255, 0.1)',
                                  }}
                                />
                              </div>

                              <div className="tbp-newcredit-field tbp-newcredit-field--minimum"
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  width: '31vw',
                                  height: '83vh',
                                }}
                              >
                                <p 
                                  style={{ 
                                    textAlign: 'left',
                                    textAlignVertical: 'center',
                                    fontSize: 17, 
                                    fontWeight: '600', 
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                    marginTop: 30, 
                                    marginBottom: 30,
                                    height: 50,
                                    width: '25vw',
                                    // textUnderlineOffset: 3, 
                                    // textDecorationLine: 'underline', 
                                    // textDecorationColor: 'rgba(255, 255, 255, 1)',
                                  }}
                                >
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    "Eliga el pago mínimo que pagarás a més mientras estas en buen estatus de pagar. "
                                      :
                                    "Set the Minimum Repayment you'll pay each month to keep your account up-to-date." 
                                  }
                                </p>

                                <p className="tbp-newcredit-unit"
                                  style={{
                                    position: 'absolute',
                                    top: '15vh', 
                                    left: '18vw',
                                    fontSize: 65,
                                    fontWeight: '600',
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 1)',
                                  }}
                                >
                                  {'USD'}
                                </p>
                                <input className="tbp-newcredit-input" 
                                  type="text" 
                                  id="text" 
                                  outline="none"
                                  autocomplete="off"
                                  disabled={that.state.readyForFinalizationBool}
                                  maxLength={3}
                                  onChange={(event) => {
                                      that.setState({
                                        minLoanInput: Number(event.target.value).toFixed(0)
                                      })
                                  }} 
                                  name="text"
                                  placeholder={`${Number(that.state.minLoanInput).toFixed(0)}`} 
                                  style={{
                                      fontWeight: '600',
                                      fontFamily: 'arial',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      padding: '3vw',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      fontSize: 18,
                                      height: '20vh',
                                      width: '25vw',
                                      borderRadius: 0,
                                      borderStyle: 'none',
                                      borderWidth: 0,
                                      fontSize: 80,
                                      borderColor: 'rgba(177, 177, 177, 0)',
                                      backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(255, 255, 255, 0.1)',
                                    }}
                                />
                              </div>


                            </div>
                            <div
                              className='flipContainer active tbp-newcredit-actions'
                              style={{
                                width: '62vw',
                                height: '30vh',
                                display: 'flex',
                                flexDirection:  'column',
                                borderRadius: 3,
                                borderColor: 'rgba(177, 177, 177, 1)',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderColor: 'green',
                                top: '50vh',
                                paddingLeft: 0,
                                paddingRight: 50,
                                marginLeft: '3vw',
                              }}
                            >
                              <Button className="tbp-newcredit-primary" 
                                onClick={() => {

                                  if(Number(that.state.minLoanInput) >= 1 && Number(that.state.intRate_commOffer_Input) >= 1){
                                    that.setState({
                                      readyForFinalizationBool: true,
                                    })
                                    that.setAgreementTextObj()

                                  } else {
                                    that.setState({
                                      readyForFinalizationBool: false,
                                      errorTags:
                                        <p
                                          style={{
                                            textAlign: 'left',
                                          }}
                                        >
                                          {that.state.selectedLanguage == 'spanish' ? 
                                            'Pago Mensual Minimo o Tasa de Interés se está bajo.'
                                            :
                                            'Minimum Monthly Repayment or Annual Interest Rate is too low.'
                                          }
                                        </p>
                                    })
                                  }
                                }}
                                style={{
                                  width: '56vw',
                                  height: '10vh',
                                  marginRight: '3vw',
                                  borderColor: 'rgba(256, 256, 256, 1)',
                                  borderRadius: 0, 
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  zIndex: 9999,
                                  marginBottom: 35,
                                  backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(255, 255, 255, 0.1)',
                                }}
                                disabled={that.state.readyForFinalizationBool}
                              >                  
                                <p style={{ fontSize: 25, textAlign: 'center', position: 'relative' , textAlignVertical: 'top', fontWeight: '600', marginBottom: 5, color: 'rgba(0, 158, 129, 1)', }}> 
                                {that.state.selectedLanguage == 'spanish' ? 
                                    'Confirmar'
                                      :
                                    'Confirm'
                                  }
                                </p>
                              </Button>

                              <Button className="tbp-newcredit-secondary" 
                                onClick={() => {
                                  that.setState({
                                    readyForFinalizationBool: false,
                                    minLoanInput: null,
                                    intRate_commOffer_Input: null,
                                  })
                                }}
                                style={{
                                  width: '40vw',
                                  height: '8vh',
                                  marginRight: '3vw',
                                  borderRadius: 0, 
                                  borderColor: 'rgba(256, 256, 256, 1)',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  zIndex: 9999,
                                  backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(255, 255, 255, 0.1)',
                                }}
                              >                  
                                <p 
                                  style={{ 
                                    fontSize: 20, 
                                    textAlign: 'center', 
                                    position: 'relative', 
                                    textAlignVertical: 'top', 
                                    fontWeight: '500', 
                                    marginBottom: 5, 
                                    color: 'rgba(235, 50, 38, 1)',
                                  }}
                                > 
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'Cancelar'
                                      :
                                    'Cancel'
                                  }
                                </p>
                              </Button>

                            </div>

                            {/* <div
                              className='flipContainer next'
                              style={{
                                width: '62vw',
                                height: '83vh',
                                flexDirection: 'row',
                                display: 'flex',
                                borderRadius: 3,
                                borderColor: 'rgba(177, 177, 177, 1)',
                                justifyContent: 'center',
                                borderColor: 'green',
                              }}
                            >
                              
                            </div>


                            <div
                              className='flipContainer previous'
                              style={{
                                width: '62vw',
                                height: '83vh',
                                flexDirection: 'row',
                                display: 'flex',
                                borderRadius: 3,
                                borderColor: 'rgba(177, 177, 177, 1)',
                                justifyContent: 'center',
                                borderColor: 'yellow',
                              }}
                            >
                              
                            </div> */}

                          </div>
                        </div>

                      </div>



                    
                    </div>
                  </div>

                  <PlatformFooter language={that.state.selectedLanguage} />

                </div>


                <aside className="tbp-money-rail tbp-newcredit-rail" aria-label={that.state.selectedLanguage === 'spanish' ? 'Resumen y acuerdo de la línea de crédito' : 'Credit line summary and agreement'}>
                  <div className="tbp-newcredit-rail__inner">
                    <section className="tbp-newcredit-rail__costs">
                      <h2>{that.state.selectedLanguage === 'spanish' ? 'Resumen de costos' : 'Cost Summary'}</h2>
                      <div className="tbp-newcredit-rail__cost tbp-newcredit-rail__cost--total">
                        <span>{that.state.selectedLanguage === 'spanish' ? 'Total adeudado' : 'Total Due'}</span>
                        <strong>{`${(Number(that.state.targetValue) + Number(that.state.flatRateFIATCostConversion)).toFixed(2)} USD`}</strong>
                      </div>
                      <div className="tbp-newcredit-rail__cost">
                        <span>{that.state.selectedLanguage === 'spanish' ? 'Colateral inicial' : 'Initial Collateral'}</span>
                        <strong>{`${Number(that.state.targetValue).toFixed(2)} USD`}</strong>
                      </div>
                      <div className="tbp-newcredit-rail__cost">
                        <span>{that.state.selectedLanguage === 'spanish' ? 'Cargo de creación' : 'Creation Fee'}</span>
                        <strong>{`${Number(that.state.flatRateFIATCostConversion).toFixed(2)} USD`}</strong>
                      </div>
                    </section>

                    <section className="tbp-newcredit-rail__agreement">
                      <h2>{that.state.selectedLanguage === 'spanish' ? 'Acuerdo del Prestatario' : "Borrower's Agreement"}</h2>
                      <div
                        className="tbp-newcredit-rail__agreement-copy"
                        role="region"
                        tabIndex={0}
                        aria-label={that.state.selectedLanguage === 'spanish' ? 'Texto del acuerdo (desplázate para leer)' : 'Agreement text (scroll to read)'}
                      >
                        <p>{that.state.agreementTextObj}</p>
                      </div>
                      <Button
                        className="tbp-newcredit-rail__publish"
                        disabled={!that.state.readyForFinalizationBool}
                        onClick={() => {
                          if((Number(weiBalance) <= (Number(that.state.flatRateWeiCostConversion) + (Number(Number(that.state.targetValue).toFixed(0) + '000000000000000000'))))){
                            that.setState({
                              lowBalanceOverlay: true,
                              inProcessLoading: true,
                            })
                          } else {
                            that.setState({
                              showPasswordOverlay: true,
                              transactionConfirmationMessage: `Publish your credit line.  Your Blender Wallet will be charged ${((Number(that.state.targetValue))/1 + Number(that.state.flatRateFIATCostConversion)).toFixed(2)} USD.`,
                              inProcessLoading: true,
                            })
                          }
                        }}
                      >
                        {that.state.selectedLanguage === 'spanish' ? 'Publicar tu Línea de Crédito' : 'Publish Your Credit Line'}
                      </Button>
                    </section>
                  </div>
                </aside>

              </div>


            </div>

          </div>
    );
  }
}

export default NewBorrowingAccountDesktopRender;
